import React from 'react'

export default function PhoneInput(props) {



  function phoneMask(phone) {
    let num = phone.replace(/\D/g, '');

    num = num.substring(0, 8);
    if (num.length > 5) {
      num = num.substring(0, 5) + '-' + num.substring(5);
    }
    if (num.length > 2) {
      num = num.substring(0, 2) + '-' + num.substring(2);
    }
    return num;
  }


  return (
    <input
      type='tel'
      placeholder='Phone Number'
      value={props.value}
      onChange={(e) => {
        props.onChangeValue(phoneMask(e.target.value));
      }}
    />
  )
}
